<template>
  <div
    v-if="visible"
    class="cookie-consent"
    role="dialog"
    aria-modal="true"
    aria-labelledby="cookie-consent-title"
  >
    <div class="cookie-consent__inner">
      <div class="cookie-consent__copy">
        <h2 id="cookie-consent-title" class="cookie-consent__title">
          {{ $t("privacyPolicy.cookieConsentHeading") }}
        </h2>
        <p class="cookie-consent__text">
          {{ $t("privacyPolicy.cookieConsentDescription") }}
        </p>
      </div>
      <div class="cookie-consent__actions">
        <button
          type="button"
          class="btn btn-outline-main cookie-consent__btn"
          @click="reject"
        >
          {{ $t("privacyPolicy.cookieConsentReject") }}
        </button>
        <button
          type="button"
          class="btn g-primary-button cookie-consent__btn"
          @click="accept"
        >
          {{ $t("privacyPolicy.cookieConsentAccept") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  shouldShowConsentBanner,
  updateConsentState,
} from "../helpers/consent";
import store from "../store";

export default {
  name: "CookieConsentBanner",
  data() {
    return {
      visible: false,
    };
  },
  mounted() {
    this.refreshVisibility();
    document.addEventListener("consentGranted", this.hide);
    document.addEventListener("consentDenied", this.hide);
    document.addEventListener("openCookieConsent", this.open);
  },
  beforeDestroy() {
    document.removeEventListener("consentGranted", this.hide);
    document.removeEventListener("consentDenied", this.hide);
    document.removeEventListener("openCookieConsent", this.open);
  },
  methods: {
    config() {
      return store.state.config.currentConfig || store.state.config.defaultConfig || {};
    },
    refreshVisibility() {
      this.visible = shouldShowConsentBanner(this.config());
    },
    open() {
      this.visible = true;
    },
    hide() {
      this.visible = false;
    },
    accept() {
      updateConsentState("granted", this.config());
      this.visible = false;
      this.$emit("accepted");
    },
    reject() {
      updateConsentState("denied", this.config());
      this.visible = false;
      this.$emit("rejected");
    },
  },
};
</script>

<style scoped>
.cookie-consent {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1050;
  padding: 16px;
  background: rgba(255, 255, 255, 0.98);
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 -8px 24px rgba(0, 0, 0, 0.08);
}

.cookie-consent__inner {
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  gap: 24px;
  align-items: center;
  justify-content: space-between;
}

.cookie-consent__title {
  font-size: 1.125rem;
  margin: 0 0 6px;
  color: #222;
}

.cookie-consent__text {
  margin: 0;
  color: #555;
  font-size: 0.95rem;
  line-height: 1.45;
}

.cookie-consent__link {
  color: var(--main, #ff762b);
  text-decoration: underline;
}

.cookie-consent__actions {
  display: flex;
  gap: 12px;
  flex-shrink: 0;
}

.cookie-consent__btn {
  white-space: nowrap;
}

@media (max-width: 768px) {
  .cookie-consent__inner {
    flex-direction: column;
    align-items: stretch;
  }

  .cookie-consent__actions {
    flex-direction: column;
  }

  .cookie-consent__btn {
    width: 100%;
  }
}
</style>
